import styled from 'styled-components';

export const SearchContainer = styled.div`
    width: 100%;
    cursor: text;
`;
